import { userSlice } from '../slices';

export const { clearUsers, setUserLoader } = userSlice.actions;
